import Vue from 'vue'
import App from './App.vue'
import store from './store'
import i18n from './locales'
import './assets/scss/app.scss'

Vue.config.productionTip = false

new Vue({
    store,
    i18n,
    render: function (h) { return h(App) }
}).$mount('#app')
